import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import { ThemeProvider } from 'styled-components';
import { GlobalStyle } from 'yankees-react-utils';
import { useHistory } from 'react-router-dom';
import { Security } from '@okta/okta-react';
import { OktaAuth, toRelativeUrl } from '@okta/okta-auth-js';
import track from 'react-tracking';
import { PlayerPortalProvider } from './store';
import Routes from './Routes';

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnReconnect: false,
            refetchOnWindowFocus: false,
            cacheTime: 3600000,
        },
    },
});

const isInDarkModeSetting = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;
const App = (properties) => {
    const oktaAuth = new OktaAuth(properties.OktaAuth);
    const history = useHistory();
    const restoreOriginalUri = async (_oktaAuth, originalUri) => {
        history.replace(toRelativeUrl(originalUri, window.location.origin));
    };
    const theme = {
        isDarkMode: false && isInDarkModeSetting,
    };
    return (
        <QueryClientProvider client={queryClient}>
            <PlayerPortalProvider>
                <Security oktaAuth={oktaAuth} restoreOriginalUri={restoreOriginalUri}>
                    <ThemeProvider theme={theme}>
                        <GlobalStyle />
                        <div>
                            <Routes />
                        </div>
                    </ThemeProvider>
                </Security>
            </PlayerPortalProvider>
        </QueryClientProvider>
    );
};

const TrackedApp = track(
    // app-level tracking data
    { Host: window.location.hostname },
    // top-level options
    {
        // custom dispatch behavior
        dispatch: (data) => {
            // console.log(data);
            if (data?.UserName && data?.PlayerID) {
                fetch('/api/usagetracking', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(data),
                });
            }
        },
    },
)(App);

export default TrackedApp;
